module.exports = __webpack_public_path__ + "static/media/bronze2.3b5d661b.png";